import React from 'react';

function Triangle() {
  return (
    <div
      style={{
        width: 0,
        height: 0,
        borderLeft: "0.4rem solid transparent",
        borderRight: "0.4rem solid transparent",
        borderTop: "0.4rem solid rgba(0,0,0,0.75)",
        borderBottomRightRadius: "2px",
      }}></div>
  );
}

export default Triangle;
